import { render } from "./ChatBubble.vue?vue&type=template&id=8149d01a&scoped=true&ts=true"
import script from "./ChatBubble.vue?vue&type=script&lang=ts"
export * from "./ChatBubble.vue?vue&type=script&lang=ts"

import "./ChatBubble.vue?vue&type=style&index=0&id=8149d01a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8149d01a"]])

export default __exports__